const _temp0 = require("./js/components/anchor.js");
const _temp1 = require("./js/components/border.js");
const _temp2 = require("./js/components/button.js");
const _temp3 = require("./js/components/footer.js");
const _temp4 = require("./js/components/header.js");
const _temp5 = require("./js/components/lamp.js");
module.exports = {
  "anchor": _temp0,
  "border": _temp1,
  "button": _temp2,
  "footer": _temp3,
  "header": _temp4,
  "lamp": _temp5
}